import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { Text } from 'app/components/Typography/Text';
import { TextProps } from 'antd/lib/typography/Text';

const STATUS = {
  error: '#ED4646',
  success: '#1EC000',
  default: '#232B3A',
  disabled: '#808080'
};

const TextWithStatus = styled(Text, {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'status'
})`
  color: ${(
    props: Partial<
      TextProps & {
        status: 'error' | 'success' | 'disabled';
      }
    >
  ) => STATUS[props.status || 'default']};
`;

export default TextWithStatus;
